import * as Cesium from 'cesium';
import { APP_CONFIG } from '../config/appConfig';

export function flyToTokushimaCenter(viewer: Cesium.Viewer): Promise<void> {
  const { camera } = APP_CONFIG;

  return new Promise((resolve) => {
    viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        camera.longitude,
        camera.latitude,
        camera.height,
      ),
      orientation: {
        heading: Cesium.Math.toRadians(camera.heading),
        pitch: Cesium.Math.toRadians(camera.pitch),
        roll: Cesium.Math.toRadians(camera.roll),
      },
      duration: camera.duration,
      complete: () => {
        viewer.scene.requestRender();
        resolve();
      },
      cancel: () => {
        viewer.scene.requestRender();
        resolve();
      },
    });
  });
}
